import { useIsMobileDevice } from '@eventbrite/feature-detection';
import { gettext } from '@eventbrite/i18n';
import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import {
    PLACE_ID_TO_PRIDE_COLLECTION_MAP,
    PRIDE_TOUCHPOINT_IMAGES,
} from '../../constants/seasonal';
import styles from './PridePageTouchpoint.module.scss';

export const PridePageTouchpoint = (props: {
    currentPlace: string;
    placeId: string;
}) => {
    const { currentPlace, placeId } = props;
    const isMobile = useIsMobileDevice();
    if (
        !Object.hasOwnProperty.call(PLACE_ID_TO_PRIDE_COLLECTION_MAP, placeId)
    ) {
        return null;
    }

    const ctaLink = `/c/${PLACE_ID_TO_PRIDE_COLLECTION_MAP[placeId]}`;

    const prideTouchpointHeading = gettext("EDITOR'S PICKS");
    const prideTouchpointTitle = gettext(
        'Find your Pride in %(currentPlace)s',
        { currentPlace },
    );
    const prideTouchpointSubtitle = gettext('by Eventbrite');

    const touchpointData = [
        {
            className: styles.pridePageTouchpointHeading,
            text: prideTouchpointHeading,
        },
        {
            className: styles.pridePageTouchpointTitle,
            text: prideTouchpointTitle,
        },
        {
            className: styles.pridePageTouchpointSubtitle,
            text: prideTouchpointSubtitle,
        },
    ];

    return (
        <div className={styles.pridePageTouchpoint}>
            <div className={styles.pridePageTouchpointContainer}>
                <div className={styles.pridePageTouchpointImageTextContainer}>
                    <img
                        className={styles.pridePageTouchpointImageContainer}
                        src={
                            isMobile
                                ? PRIDE_TOUCHPOINT_IMAGES['imgMobile']
                                : PRIDE_TOUCHPOINT_IMAGES['imgDesktop']
                        }
                        alt="Pride Touchpoint"
                    />
                    <div
                        className={styles.pridePageTouchpointTextContainer}
                        data-testid="pride-page-touchpoint-heading-title-subtitle"
                    >
                        {touchpointData.map((item, index) => (
                            <Typography
                                key={index}
                                as="h2"
                                className={item.className}
                            >
                                {item.text}
                            </Typography>
                        ))}
                    </div>
                </div>
                <a
                    href={ctaLink || ''}
                    data-heap-id="pride_page_touchpoint_click"
                >
                    <Button className={styles.pridePageTouchpointButton}>
                        <span className={styles.pridePageTouchpointButtonText}>
                            {gettext('Explore')}
                        </span>
                        <ArrowRightIcon
                            className={styles.pridePageTouchpointArrowRight}
                        />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default PridePageTouchpoint;
